import { useRef, useState } from "react";
import { useResizeObserver } from "@hooks";

export const useTableOverflowChecker = (
  headerRef,
  onResize,
  onScroll,
) => {
  const [ isTableContentOverflowing, setOverflowing ] = useState(false);
  const [ containerWidth, setContainerWidth ] = useState();
  const [ scrollReachedStart, setReachedStart ] = useState(false);
  const [ scrollReachedEnd, setReachedEnd ] = useState(false);
  
  const containerRef = useRef(null);
  
  const handleScroll = () => {
    if(!containerRef.current) return;
    const s = containerRef.current.scrollLeft;
    const w = containerRef.current.scrollWidth - containerRef.current.offsetWidth;
    if(s <= 0 || scrollReachedStart)
      setReachedStart(s <= 0)
    if(s >= w || scrollReachedEnd)
      setReachedEnd(s >= w)
    
    onScroll?.(s, w);
  }

  const handleResize = () => {
    if(!containerRef.current) return;
    if (headerRef) {
      const o = containerRef.current.offsetWidth < headerRef.offsetWidth;
      if (o !== isTableContentOverflowing) setOverflowing(o);
      
      setContainerWidth(containerRef.current.offsetWidth);
      
      onResize?.(containerRef.current.offsetWidth);
    }
    
    handleScroll();
  };
  
  useResizeObserver(handleResize, containerRef.current);
  
  return {
    ref: containerRef,
    onScroll: handleScroll,
    onResize: handleResize,
    isTableContentOverflowing,
    containerWidth,
    scrollButtonProps: {
      containerRef,
      scrollReachedStart,
      scrollReachedEnd,
    }
  };
};
